import { resetStore } from "../../store/store";

// Resets every Redux slice to its initialState (see RESET_STORE in store.js)
export const clearAllReduxStates = (dispatch) => {
    dispatch(resetStore());
}

export const clearAllReduxStatesnew = (dispatch) => {
    return new Promise((resolve) => {
        dispatch(resetStore());
        resolve();
    });
}
